import Footer from "./components/Footer";
import InteractiveMap from "./components/InteractiveMap";

import Navigation from "./components/navigation";

function App() {
  return (
    <div className="App">
      <Navigation />
      <InteractiveMap />

      <Footer />
    </div>
  );
}

export default App;
